import Button from "components/button";
import PropTypes from "prop-types"
import { Row, Col } from "react-flexbox-grid";
import intl from 'react-intl-universal'

const ActionsFooterDialog = ({ save, close }) => (
  <Row between="xs" style={{ width: '100%' }}>
    <Col xs={4}>
      <Button
        buttonType="default"
        className='btn-icon'
        value={intl.get('geral.buttonsDefault.cancel')}
        onClick={close}
      />
    </Col>
    <Col xs={4}>
      <Button
        buttonType="primary"
        className='btn-icon'
        value={intl.get('geral.buttonsDefault.send')}
        onClick={save}
      />
    </Col>
  </Row>
)

ActionsFooterDialog.propTypes = {
  close: PropTypes.any.isRequired,
  save: PropTypes.any.isRequired
}

export default ActionsFooterDialog;
